import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import FlatVDPPaneContent from 'components/shared/FlatVDPPaneContent';

import { useWindowSize } from 'hooks';
import { useVehicleSummary } from 'api';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import ReconProgressSection from './ReconProgressSection';
import ReconInfoSection from './ReconInfoSection';
import StepProgressSection from './StepProgressSection';

import './ReconVelocityOverview.scss';

interface ReconVelocityOverviewProps {
  mobileVDPInfoHeight?: number;
  vehicleId: string;
}

const ReconVelocityOverview: React.FC<ReconVelocityOverviewProps> = ({
  mobileVDPInfoHeight = 0,
  vehicleId,
}) => {
  const windowSize = useWindowSize();
  const paddingTop = windowSize.isMobileViewport()
    ? { paddingTop: 68 - mobileVDPInfoHeight }
    : {};
  const {
    data: { data: vehicleSummary } = {},
    isLoading: vehicleSummaryIsLoading,
  } = useVehicleSummary(vehicleId);
  return (
    <div style={paddingTop}>
      <Container fluid className="ReconVelocityOverview">
        <FlatVDPPaneContent>
          {vehicleSummary && !vehicleSummaryIsLoading ? (
            <>
              <Row noGutters>
                <Col md={12} lg={6}>
                  <ReconProgressSection
                    vehicleSummary={vehicleSummary}
                    vehicleId={vehicleId}
                  />
                </Col>
                <Col md={12} lg={6} className="ReconVelocityOverview-separator">
                  <ReconInfoSection vehicleSummary={vehicleSummary} />
                </Col>
              </Row>
              <Row noGutters>
                <Col>
                  <StepProgressSection vehicleSummary={vehicleSummary} />
                </Col>
              </Row>
            </>
          ) : (
            <LoadingIndicator />
          )}
        </FlatVDPPaneContent>
      </Container>
    </div>
  );
};

export default ReconVelocityOverview;
